
import { driverColNm } from "constants/driverConstant"
import { pettyCashColNm } from "pages/Menu1/PettyCash/constant";
import { numberFormat } from "utils";

export const columns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "DrvCd",
    headerName: driverColNm.DrvCd,
    width: 100,
  },
  {
    field: "DrvNm",
    headerName: driverColNm.DrvNm,
    width: 200,
  },
  {
    field: "Amnt",
    headerName: pettyCashColNm.Amnt,
    width: 120,
    type: "number",
    align: 'right',
    editable: true,
    valueFormatter: ({value}) =>  value? numberFormat(+value): "-"
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    width: 250,
    editable: true,
  },
]